import {lazy} from "react";
import { BaseRouter } from "app/model/common/baseRouter";
import { Navigate } from "react-router-dom";
import NavigateWrapper from "app/pages/common/NavigateWrapper";
const SignUpLayout = lazy(() => import("app/components/layout/SignUpLayout"));
const SignUpType = lazy(() => import("../pages/signUp/SignUpType"));
const SignUpFormBase = lazy(() => import("app/pages/signUp/SignUpFormBase")) ;
const NotPermission = lazy(() => import("app/pages/error/NotPermission"));
const NotFound = lazy(() => import("app/pages/error/NotFound"));
const InvalidAccess = lazy(() => import("app/pages/error/InvalidAccess"));
const ServerError = lazy(() => import("app/pages/error/ServerError"));

export const publicRouter: BaseRouter[] = [
  // { path: "/", element: <Navigate to="/db" replace /> },
  { path: "/", element: <NavigateWrapper /> },
  { path: "/logout", element: <Navigate to="/db" replace /> },
  { path: "/sign-up", element: <SignUpLayout />,
    children:[
      { path: "/sign-up/type", element: <SignUpType /> },
      { path: "/sign-up/form", element: <SignUpFormBase />}
    ] },
  { path: '/not-permission', element: <NotPermission /> },
  { path: '/not-found', element: <NotFound /> },
  { path: '/invalid-access', element: <InvalidAccess /> },
  { path: '/server-error', element: <ServerError /> },
];
